<div class="onboarding-container">
  <!-- Step Indicator -->
  <div class="step-indicator">
    <div class="step-circle">Step 3</div>
  </div>

  <!-- Rocket Icon -->
  <div class="rocket-section">
    <div>
      <img src="assets/images/slang-to-the-moon.png" alt="Sling to the Moon" class="rocket-image">
    </div>
  </div>

  <!-- Description Text -->
  <div class="description-text">
    <h2>Login using <span class="highlight">{{ carrierData?.companyName || 'Positive Trucking Inc' }}</span> link again to apply</h2>
  </div>

  <!-- Confirmation Message -->
  <div class="confirmation-box">
    <p>You will receive a confirmation email with details</p>
  </div>

  <!-- Complete Button -->
  <div class="action-section">
    <button class="complete-btn" (click)="onComplete()">
      Start now
    </button>
  </div>

  <!-- Pagination Dots -->
  <div class="pagination-dots">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot active"></div>
  </div>
</div>
